/** @jsxImportSource @emotion/react */

// import { css } from "@emotion/react";
import PlaceMapMap from "component/molecule/PlaceMapMap";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import MainLayout from "layout/MainLayout";
import { useEffect } from "react";
import { placeMapReadDocument } from "service/placeMapService";
import { storeOriginPlaceList, storePlaceList } from "store/placeValue";
import { storeSearchCategory, storeSearchCity, storeSearchGu, storeSearchKeyword, storeSearchStart, storeSearchSubCategory } from "store/searchValue";

export default function PlaceMap() {
    const [originPlaceList, setOriginPlaceList] = useAtom(storeOriginPlaceList)
    const setPlaceList = useSetAtom(storePlaceList)
    const searchCategory = useAtomValue(storeSearchCategory)
    const searchSubCategory = useAtomValue(storeSearchSubCategory)
    const searchCity = useAtomValue(storeSearchCity)
    const searchGu = useAtomValue(storeSearchGu)
    const searchKeyword = useAtomValue(storeSearchKeyword)
    const searchStart = useAtomValue(storeSearchStart)

    useEffect(() => {
        getFirebaseDocument()
    }, [searchStart])

    const getFirebaseDocument = async () => {
        // 가져오기
        const querySnapshot = await placeMapReadDocument("place")

        // 변환
        let tmpMarkerList = new Array()
        querySnapshot.forEach((doc) => {
            tmpMarkerList.push(doc.data())
        });

        const newList = tmpMarkerList.filter((item) => (
            item.category.includes(searchCategory)
            && item.sub_category.includes(searchSubCategory)
            && item.addr1.includes(searchCity)
            && item.addr1.includes(searchGu)
            && (item.title.includes(searchKeyword) || item.info.addr1.includes(searchKeyword) )
        ))

        // setting
        setOriginPlaceList(tmpMarkerList)

        // @ts-ignore
        setPlaceList(newList)
    }

    return (
        <MainLayout>
            <PlaceMapMap />
        </MainLayout>
    )
}